import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  effect,
  ElementRef,
  input,
  viewChild,
} from '@angular/core';
import { PlayerAvatarComponent } from '@core/components/player-avatar/player-avatar.component';
import { UserLevelComponent } from '@core/components/user-level/user-level.component';
import { User } from '@core/interfaces/user.interface';
import NumberFlow from 'number-flow';

@Component({
  selector: 'app-header-user',
  imports: [UserLevelComponent, PlayerAvatarComponent],
  templateUrl: './header-user.component.html',
  styleUrl: './header-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
})
export class HeaderUserComponent {
  user = input.required<User>();

  currExpNumberFlow =
    viewChild.required<ElementRef<NumberFlow>>('currExpNumberFlow');
  nextExpNumberFlow =
    viewChild.required<ElementRef<NumberFlow>>('nextExpNumberFlow');

  constructor() {
    effect(() => {
      const currElement = this.currExpNumberFlow().nativeElement;
      const nextElement = this.nextExpNumberFlow().nativeElement;

      currElement.update(this.user().xp);
      nextElement.update(this.user().xpNeeded);
    });
  }
}
